import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Work',
    path: '/work'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'Studio',
    path: '/studio'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/90 backdrop-blur-md py-4 border-b border-white/10' : 'bg-transparent py-8'}`} data-id="element-77">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-78">
        {/* Logo */}
        <Link to="/" className="text-2xl font-black tracking-tighter text-white group" data-id="element-79">
          KUJODO
          <span className="text-yellow-400 group-hover:text-white transition-colors" data-id="element-80">
            .
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-12" data-id="element-81">
          {navLinks.map(link => {
          const isActive = location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path);
          return <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors uppercase tracking-widest ${isActive ? 'text-yellow-400' : 'text-gray-400 hover:text-yellow-400'}`} data-id="element-82">
                {link.name}
              </Link>;
        })}
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white hover:text-yellow-400 transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-83">
          {isMobileMenuOpen ? <X data-id="element-84" /> : <Menu data-id="element-85" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-black border-b border-white/10 p-6 md:hidden flex flex-col space-y-4 h-screen" data-id="element-86">
          {navLinks.map(link => <Link key={link.name} to={link.path} className="text-2xl font-bold text-white hover:text-yellow-400 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-87">
              {link.name}
            </Link>)}
        </div>}
    </nav>;
}